import React from 'react';
import Navbar from './global-components/navbar';
import PageHeader from './global-components/page-header';
import CallToActionV1 from './section-components/call-to-action-v1';
import Footer from './global-components/footer';
import ProductListingV1 from './section-components/product-listing';

const Shop_V1 = () => {
    return <div>
        <Navbar />
        <PageHeader headertitle="Projects" />
        <ProductListingV1 />
        <CallToActionV1 />
        <Footer />
    </div>
}

export default Shop_V1

